import React from "react";
import { Logo } from "../../assets/images";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faCircleInfo, 
  faPhone, 
  faEnvelope, 
  faGraduationCap, 
  faPeopleGroup, 
  faLink,
  faMapMarkerAlt
} from "@fortawesome/free-solid-svg-icons";
import "./footer.css";
const Footer = () => {
  return (
    <div className="footerContainer w-full shadow-lg	 bg-[#f9f6f1] pt-7 pb-3 px-4 sm:px-6 md:px-12 lg:px-24"  style={{ boxShadow: "0 -8px 15px -4px rgba(0, 0, 0, 0.2)" }}>
      <div className="mx-auto max-w-7xl ">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-5 lg:gap-12">
          <div className="flex flex-col items-center space-y-6 md:items-start">
            <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:text-left">
              <img
                alt="logo"
                src={Logo}
                className="object-cover w-20 h-28 lg:w-20 lg:h-20 rounded-xl "
              />
              <div>
                <h2 className="mt-2 text-xl font-bold sm:mt-0">FOK NJE7EK</h2>
                <p className="text-sm opacity-80">Apprendre, grandir, réussir</p>
              </div>
            </div>
            
            <div className="w-full space-y-3">
              <div className="flex items-center justify-center footerContact md:justify-start">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="fa w-5 text-center text-[#048c6b]" />
                <p className="ml-3">Tunis, Tunisia</p>
              </div>
              <div className="flex items-center justify-center footerContact md:justify-start">
                <FontAwesomeIcon icon={faPhone} className="fa w-5 text-center text-[#048c6b]" />
                <p className="ml-3">+216 51 347 528</p>
              </div>
              <div className="flex items-center justify-center footerContact md:justify-start">
                <FontAwesomeIcon icon={faEnvelope} className="fa w-5 text-center text-[#048c6b]" />
                <p className="ml-3">foknjeikacademy@gmail.com</p>
              </div>
            </div>
            
            <div className="flex justify-center pt-2 space-x-4 linkss md:justify-start">
              <a
                href="https://www.facebook.com/profile.php?id=100069589923551"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FacebookOutlinedIcon className="text-[#1028ff]" style={{ fontSize: 28 }} />
              </a>
              <a
                href="https://www.instagram.com/fok.nje7ek?igsh=eGU5ZWI0cjFmdDBi"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <InstagramIcon className="text-[#f501dd]" style={{ fontSize: 28 }} />
              </a>
              <a
                href="https://youtube.com/@foknje7ik?si=Gx6DuBqwdkokJLUl"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <YouTubeIcon className="text-[#ff1010]" style={{ fontSize: 28 }} />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center lg:col-span-1 md:items-start">
            <div className="flex items-center courses-title">
              <FontAwesomeIcon icon={faGraduationCap} className="fa w-5 text-[#048c6b]" />
              <h3 className="ml-3 text-lg font-bold">Cours</h3>
            </div>
            <div className="w-full mt-4 space-y-3 footer-informations">
              <p className="text-center footer-link md:text-left">Cours en classroom</p>
              <p className="text-center footer-link md:text-left">Cours E-learning</p>
              <p className="text-center footer-link md:text-left">Cours vidéo</p>
              <p className="text-center footer-link md:text-left">Cours gratuits</p>
            </div>
          </div>

          <div className="flex flex-col items-center lg:col-span-1 md:items-start">
            <div className="flex items-center courses-title">
              <FontAwesomeIcon icon={faPeopleGroup} className="fa w-5 text-[#048c6b]" />
              <h3 className="ml-3 text-lg font-bold">Communauté</h3>
            </div>
            <div className="w-full mt-4 space-y-3 footer-informations">
              <p className="text-center footer-link md:text-left">Apprenants</p>
              <p className="text-center footer-link md:text-left">Partenaires</p>
              <p className="text-center footer-link md:text-left">Blog</p>
              <p className="text-center footer-link md:text-left">Centre d'enseignement</p>
            </div>
          </div>

          <div className="flex flex-col items-center lg:col-span-1 md:items-start">
            <div className="flex items-center courses-title">
              <FontAwesomeIcon icon={faLink} className="fa w-5 text-[#048c6b]" />
              <h3 className="ml-3 text-lg font-bold">Liens rapides</h3>
            </div>
            <div className="w-full mt-4 space-y-3 footer-informations">
              <p className="text-center footer-link md:text-left">Accueil</p>
              <p className="text-center footer-link md:text-left">Education</p>
              <p className="text-center footer-link md:text-left">Admissions</p>
              <p className="text-center footer-link md:text-left">Témoignages</p>
            </div>
          </div>

          <div className="flex flex-col items-center lg:col-span-1 md:items-start">
            <div className="flex items-center courses-title">
              <FontAwesomeIcon icon={faCircleInfo} className="fa w-5 text-[#048c6b]" />
              <h3 className="ml-3 text-lg font-bold">Plus d'infos</h3>
            </div>
            <div className="w-full mt-4 space-y-3 footer-informations">
              <p className="text-center footer-link md:text-left">Termes</p>
              <p className="text-center footer-link md:text-left">Politique de confidentialité</p>
              <p className="text-center footer-link md:text-left">Aide</p>
              <p className="text-center footer-link md:text-left">Contact</p>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-4 pt-3 mt-3 text-center border-t border/20">
          <p className="text-sm opacity-80">
            <span className="fa">©</span> 2025 FOK NJE7EK. Tous droits réservés.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <p className="text-sm opacity-80">Conditions d'utilisation</p>
            <p className="text-sm opacity-80">Politique de confidentialité</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;